module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.wrapperClass
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [(_vm.showPrice) ? _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-space-between": "",
      "row": ""
    }
  }, [_c('span', {
    staticClass: "paypal__price-text"
  }, [_vm._v(_vm._s(_vm.plan.displayName))]), _vm._v(" "), _c('span', {
    staticClass: "paypal__price-text--bold"
  }, [_vm._v(_vm._s(_vm.price) + " " + _vm._s(_vm.plan.currency) + " / " + _vm._s(_vm.period))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "paypal__button",
    attrs: {
      "id": "paypal-button"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }, [_c('v-layout', {
    staticClass: "page__section",
    attrs: {
      "align-center": "",
      "justify-center": "",
      "row": "",
      "fill-height": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 70,
      "width": 7,
      "color": "black",
      "indeterminate": ""
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-474804d2","hasScoped":false}!./app/components/paypal/template.html
// module id = 355
// module chunks = 0